jQuery.extend(jQuery.easing, {
    easeOutQuint: function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }
});

/*!
* jquery.smoothwheel.js 0.1 - https://github.com/yckart/smoothWheel
* Scroll pages smoothy!
*
* Copyright (c) 2012 Yannick Albert (http://yckart.com)
* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php).
* 2012/10/20
*/
;(function($, window, document, undefined) {
    "use strict";
    $.smoothWheel = $.fn.smoothWheel = function(options) {
        options = $.extend({}, $.fn.smoothWheel.options, options);

        if (!(this instanceof $)) {
            return $.fn.smoothWheel.apply( $('body') , arguments);
        }

        return this.each(function() {
            var elem = $(this),
                win = $(window)[options.axis === 'y' ? 'height' : 'width'](),
                doc = $(document)[options.axis === 'y' ? 'height' : 'width'](),
                range = 0,
                wheel = false;


            // Stops jumping during scrolling with scrollbars
            $(window).scroll(function() {
                if (wheel === false) {
                    range = $(this)[options.axis === 'y' ? 'scrollTop' : 'scrollLeft']();
                }
            });

            elem.bind('DOMMouseScroll mousewheel', function(e, delta) {
                delta = delta || -e.originalEvent.detail / 3 || e.originalEvent.wheelDelta / 120;
                wheel = true;

                if (delta < 0) {
                    range = (range + win) >= doc ? range : range += options.step;
                    elem.stop().animate(options.axis === "y" ? {
                        scrollTop: range
                    } : {
                        scrollLeft: range
                    }, options.speed, options.easing, function() {
                        options.callbackR();
                        wheel = false;
                    });
                } else {
                    range = range <= 0 ? 0 : range -= options.step;
                    elem.stop().animate(options.axis === "y" ? {
                        scrollTop: range
                    } : {
                        scrollLeft: range
                    }, options.speed, options.easing, function() {
                        options.callbackL();
                        wheel = false;
                    });
                }

                if (options.preventDefault) {
                    e.preventDefault();
                }
            });
        });
    };

    $.fn.smoothWheel.options = {
        axis: 'y',
        step: 60,
        speed: 1200,
        easing: "easeOutQuint",
        preventDefault: true,
        callbackL: function() {},
        callbackR: function() {}
    };

})(jQuery, window, document);

$(function() {
    //$.smoothWheel({
    //    axis: 'y'
    //});
});